
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/team/league-table",
      function () {
        return require("private-next-pages/team/league-table.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/team/league-table"])
      });
    }
  